import { getBlockConfig } from '../../templateEditor/BlockConfigs'
import { Block, TemplateData } from '../../types/blueprint'

const mapField = (block: Block) => {
  const config = getBlockConfig(block.kind, block.type)

  if (!config) return block

  return config.mapBlockToDisplayBlock(block)
}

const mapCaptureToDisplay = (template: TemplateData) => {
  const formattedTemplate = {
    ...template,
    sections: template?.sections?.map((section) => ({
      ...section,
      blockGroups: section?.blockGroups?.map((blockGroup) => ({
        ...blockGroup,
        blocks: blockGroup?.blocks?.map((block) => {
          return mapField(block)
        }),
      })),
    })),
  }

  return formattedTemplate
}

export const mapCaptureBlockToDisplay = (block: Block) => mapField(block)

export default mapCaptureToDisplay
